import './src/libs/polyfill';
import * as ThumbPlayerCore from './exports';
import { KERNEL_NAME } from './src/enums';
import OrgPlayer from './src/kernel-origin/org-player';
import KernelFactory from './src/kernel-selector/kernel-factory';
import { mountGlobal } from './src/util/module-loader';
export * from './exports';
// tee依赖这个库并且被JsArmor混淆，因此需要有default具名导出，否则二次编译会出现类似以下错误
// [!] Error: 'default' is not exported by . ./core/lib/index. js, imported by ../tvk/lib/index.esm.js
export default ThumbPlayerCore;
// 播放器自带原生播放内核
KernelFactory.registerKernel(KERNEL_NAME.ORIGIN, OrgPlayer);
mountGlobal({
    globalName: 'ThumbPlayerCore',
    target: ThumbPlayerCore,
    onDuplicate: function () {
        console.warn('Possible duplicated ThumbPlayerCore detected. Avoid to import this package multiple times.');
    },
});
;
